import { ScopeVersion } from '@app/core/model/scope-version'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { ScopeSection } from '../../model/scope-section'
import { Dictionary } from 'lodash'
import { ChangeItem, ChangeType } from '../model'

export function mapScopeSections(scope: ScopeVersion, changeItemsMap?: Dictionary<ChangeItem>): ScopeSection[] {
  return [...(scope?.sections || [])]
    .sort((a, b) => a.order - b.order)
    .map((section) =>
      plainToInstance(ScopeSection, {
        ...section,
        deliverables: (scope?.deliverables || [])
          .filter((deliverable: Deliverable) => {
            const changeItem = changeItemsMap?.[deliverable.changeAuditData?.identity]
            return (
              deliverable.section?.id === section.id ||
              (changeItem?.changeType !== ChangeType.REMOVED &&
                changeItem?.data?.section &&
                changeItem?.data?.section?.new?.id === section.id)
            )
          })
          .sort((a, b) => a.order - b.order),
      })
    )
}
